<p>move-location works!</p>
